import React, { ReactNode } from 'react'
import classnames from 'classnames'
import styled from 'styled-components'
import Box from 'shared/components/Box'

interface ParticipantFormSectionTitleProp {
  icon?: ReactNode
  title: string
  className?: string
  marginbottom?: string
}

const ParticipantFormSectionTitle: React.FC<ParticipantFormSectionTitleProp> = ({
  icon,
  title,
  className,
  marginbottom
}: ParticipantFormSectionTitleProp) => (
  <FormSectionTitleContainer className={classnames(className)} marginbottom={marginbottom}>
    {icon && typeof icon !== 'string' && (
      <SectionIcon>
        {icon}
      </SectionIcon>
    )}
    {icon && typeof icon === 'string' && (
      <SectionIcon>
        <img src={icon} />
      </SectionIcon>
    )}
    <SectionTitle>{title}</SectionTitle>
  </FormSectionTitleContainer>
)

const FormSectionTitleContainer = styled(Box)`
  height: 18px;
  display: flex;
  align-items: center;
  margin-bottom: ${(props: {marginbottom?: string}) => props.marginbottom || "30px"};


  &--margin-top-0 {
    margin-top: 0;
  }

  &--margin-top-8 {
    margin-top: 8px;
  }
`

const SectionIcon = styled(Box)`
  display: flex;
  align-items: center;
  margin-right: 10px;
  height: 18px;

  img {
    max-height: 18px;
  }
`

export const SectionTitle = styled(Box)`
  font-size: 20px;
  font-weight: bold;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.secondary};
`

export default ParticipantFormSectionTitle
